import { ReactionAdd } from '@doist/icons/product-ui';
import { Text } from '@doist/marketist';
import cn from 'clsx';
import css from './product-ui-comment.module.css';
import type { ReactNode } from 'react';
type ProductUICommentProps = {
  children: ReactNode;
  name: string;
  avatar: ReactNode;
  reactionChips?: ReactNode[];
  reactionAdd?: ReactNode;
};
function ProductUIComment({
  avatar,
  name,
  reactionChips,
  reactionAdd,
  children
}: ProductUICommentProps) {
  return <div className={css.comment} data-sentry-component="ProductUIComment" data-sentry-source-file="product-ui-comment.tsx">
            {avatar}
            <div className={css.content}>
                <div className={css.name}>
                    <Text size="minor-xs" weight="medium" data-sentry-element="Text" data-sentry-source-file="product-ui-comment.tsx">
                        {name}
                    </Text>
                </div>
                <div className={css.copy}>{children}</div>
                <div className={css.chips}>
                    {reactionChips}
                    {reactionAdd}
                </div>
            </div>
        </div>;
}
type ReactionChipProps = {
  state?: 'idle' | 'selected' | 'onhover';
  count: number;
  emoji: ReactNode;
};
ProductUIComment.ReactionChip = ({
  state = 'idle',
  count,
  emoji
}: ReactionChipProps) => {
  return <div className={cn(css.reactionChip, css[state])}>
            <Text tag="span" size="body-2xs">
                {emoji}
            </Text>
            <Text tag="span" size="body-2xs">
                {count}
            </Text>
        </div>;
};
type ReactionAddProps = {
  state?: 'idle' | 'onhover';
};
ProductUIComment.ReactionAdd = ({
  state = 'idle'
}: ReactionAddProps) => {
  return <span className={cn(css.reactionAdd, css[state])}>
            <ReactionAdd width={16} height={16} />
        </span>;
};
export { ProductUIComment };